import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['pipeline', 'stage']

  connect() { this.filter() }

  filter() {
    const pid = this.pipelineTarget.value
    let firstVisible = null
    Array.from(this.stageTarget.options).forEach((opt) => {
      const match = opt.dataset.pipeline === pid
      opt.hidden = !match
      opt.disabled = !match
      if (match && firstVisible === null) firstVisible = opt
    })
    const sel = this.stageTarget.selectedOptions[0]
    if ((!sel || sel.hidden) && firstVisible) this.stageTarget.value = firstVisible.value
  }
}
